/* custom-announcement.js — the announcement rotator (sections/custom-announcement-rotator.liquid;
   design handover "AnnouncementBar 12c", 2026-10-04).
   Rotation: every N seconds (data-rotate-seconds) the next message slides up into view and the
   current one slides out, looping; paused while a mouse pointer is over the bar, while anything in
   it has focus, while a finger is on it, and while the tab is hidden. The movement is CSS
   (.is-active / .is-leaving; the stylesheet swaps the slide for a cross-fade under
   prefers-reduced-motion). A bar marked data-static="true" (one message, or a product page with
   "first message only") never rotates. Close: hides the bar for the session, keyed by the section
   id (the section also hides a closed bar inline before first paint). Theme editor: selecting a
   message block shows that message and holds the rotation; deselecting releases it; a section
   re-render re-initialises. Idempotent per element. */
(function () {
  'use strict';

  var ACTIVE = 'is-active';
  var LEAVING = 'is-leaving';
  var HIDDEN = 'wg-announce--hidden';
  var LEAVE_MS = 450;

  function setup(bar) {
    if (bar.__wgAnnounce) return bar.__wgAnnounce;

    var key = 'wgAnnounceClosed:' + (bar.getAttribute('data-section-id') || '');
    var items = Array.prototype.slice.call(bar.querySelectorAll('.wg-announce__item'));
    var index = Math.max(0, items.map(function (item) { return item.classList.contains(ACTIVE); }).indexOf(true));
    var paused = 0; /* a count: pointer, focus, touch and the editor each hold their own pause */
    var timer = null;
    var leaving = null;
    var seconds = parseFloat(bar.getAttribute('data-rotate-seconds'));
    if (!(seconds > 0)) seconds = 6;
    var rotates = bar.getAttribute('data-static') !== 'true' && items.length > 1;

    var api = {
      show: show,
      hold: function () { paused += 1; },
      release: function () { paused = Math.max(0, paused - 1); },
      stop: function () { if (timer) { clearInterval(timer); timer = null; } }
    };
    bar.__wgAnnounce = api;

    try {
      if (bar.classList.contains('wg-announce--closable') && window.sessionStorage && sessionStorage.getItem(key) === '1') {
        bar.classList.add(HIDDEN);
      }
    } catch (error) { /* storage blocked: the bar simply shows */ }

    var close = bar.querySelector('[data-wg-announce-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.classList.add(HIDDEN);
        api.stop();
        try { if (window.sessionStorage) sessionStorage.setItem(key, '1'); } catch (error) { /* ignore */ }
      });
    }

    /* animated when moving on from the current message; instant for the editor's selection */
    function show(next, instant) {
      if (next < 0 || next >= items.length || next === index) return;
      var current = items[index];
      if (leaving) { leaving.classList.remove(LEAVING); leaving = null; }
      current.classList.remove(ACTIVE);
      current.setAttribute('aria-hidden', 'true');
      if (!instant) {
        current.classList.add(LEAVING);
        leaving = current;
        setTimeout(function () {
          if (leaving === current) { current.classList.remove(LEAVING); leaving = null; }
        }, LEAVE_MS + 50);
      }
      items[next].classList.add(ACTIVE);
      items[next].removeAttribute('aria-hidden');
      index = next;
    }

    if (!rotates) return api;

    function tick() {
      if (paused > 0 || document.hidden) return;
      show((index + 1) % items.length);
    }

    /* a mouse over the bar pauses; a finger's synthetic mouse events are ignored, the touch
       listeners pause for the finger and release when it lifts */
    bar.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') api.hold(); });
    bar.addEventListener('pointerleave', function (event) { if (event.pointerType === 'mouse') api.release(); });
    bar.addEventListener('focusin', api.hold);
    bar.addEventListener('focusout', api.release);
    bar.addEventListener('touchstart', api.hold, { passive: true });
    bar.addEventListener('touchend', api.release, { passive: true });
    bar.addEventListener('touchcancel', api.release, { passive: true });

    timer = setInterval(tick, seconds * 1000);
    return api;
  }

  function init(root) {
    var bars = (root || document).querySelectorAll('[data-wg-announce]');
    for (var i = 0; i < bars.length; i++) setup(bars[i]);
  }

  function barOf(target) {
    return target && target.closest ? target.closest('[data-wg-announce]') : null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* the theme editor: a section re-render, a block selected or deselected, a section removed */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var bars = event.target.querySelectorAll('[data-wg-announce]');
    for (var i = 0; i < bars.length; i++) if (bars[i].__wgAnnounce) bars[i].__wgAnnounce.stop();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var bar = barOf(event.target);
    if (!bar) return;
    var api = setup(bar);
    var item = event.target.closest('.wg-announce__item');
    var items = Array.prototype.slice.call(bar.querySelectorAll('.wg-announce__item'));
    api.hold();
    api.show(items.indexOf(item), true);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var bar = barOf(event.target);
    if (bar && bar.__wgAnnounce) bar.__wgAnnounce.release();
  });
})();
